import { FireworksColor, FireworksType } from "./Enum";
import { FireworksInfo } from "./Type";
import { Sounds } from "./Enum";

export const FIREWORK_INITIAL_Y_OFFSET = 560;
export const CLEARING_FW_ANIM_DURATION = 150;
export const LOADING_FW_ANIM_DURATION = 500;
export const FW_ANIM_START_INDEX = 3; // between [0 - 6]
export const PAYAMOUNTLIST = ["0.50", "1", "2", "3", "4", "5", "10", "20", "30", "50"]
export const INITIAL_FRAME_COLOR = FireworksColor.purple;
export const INITIAL_FRAME_TYPE = FireworksType.full


export const WINNING_MULTIPLIER_TABLE = {
  0: {
    0: 0,
    1: 0.5,
    2: 0.7,
    3: 1.1,
    4: 1.5,
    5: 1.8,
    6: 2,
    7: 2.2,
    8: 2.4
  },
  1: {
    0: 0,
    1: 0.3,
    2: 0.4,
    3: 0.5,
    4: 1.1,
    5: 1.6,
    6: 1.8,
    7: 2,
    8: 2.3
  },
  2: {
    0: 0,
    1: 0.5,
    2: 1,
    3: 3,
    4: 3.2,
    5: 4,
    6: 5,
    7: 5.2,
    8: 6.4
  },
  3: {
    0: 0,
    1: 0.2,
    2: 0.3,
    3: 0.5,
    4: 0.8,
    5: 1,
    6: 2,
    7: 3.2,
    8: 4.4
  },
  4: {
    0: 0,
    1: 0.6,
    2: 0.8,
    3: 1,
    4: 1.2,
    5: 2,
    6: 3,
    7: 3.2,
    8: 3.4
  }
}


export const soundList = [
  {
    name: Sounds.click1,
    url: "./sounds/Click1.wav"
  },
  {
    name: Sounds.click2,
    url: "./sounds/Click2.wav"
  },
  {
    name: Sounds.click3,
    url: "./sounds/Click3.wav"
  },
  {
    name: Sounds.clickOnBadFirework,
    url: "./sounds/ClickOnBadFirework.wav"
  },
  {
    name: Sounds.explode1,
    url: "./sounds/Explode1.wav"
  },
  {
    name: Sounds.explode2,
    url: "./sounds/Explode2.wav"
  },
  {
    name: Sounds.success,
    url: "./sounds/success.wav"
  },
  {
    name: Sounds.success2,
    url: "./sounds/success2.wav"
  },
  {
    name: Sounds.background,
    url: "./sounds/background.wav"
  }
]

export const logoPath = "./images/logo/mervquarterwhite.png";

export const winningIcons = [
  "./images/winning_icons/prize_baseball.png",
  "./images/winning_icons/prize_hotdog.png",
  "./images/winning_icons/prize_lemonade.png",
  "./images/winning_icons/prize_popsicle.png",
  "./images/winning_icons/prize_slice.png",
  "./images/winning_icons/prize_star.png"
]

export const assetList = [
  "./images/howtoplay/red_arrow.png",

  "./images/scene/b1_red.png",
  "./images/scene/b1_purple.png",
  "./images/scene/b1_green.png",
  "./images/scene/b1_blue.png",
  "./images/scene/b1_checker.png",
  "./images/scene/b1_stars.png",
  "./images/scene/b1_stripes.png",
  "./images/scene/b1_swiggle.png",

  "./images/scene/b2_red.png",
  "./images/scene/b2_purple.png",
  "./images/scene/b2_green.png",
  "./images/scene/b2_blue.png",
  "./images/scene/b2_checker.png",
  "./images/scene/b2_stars.png",
  "./images/scene/b2_stripes.png",
  "./images/scene/b2_swiggle.png",

  "./images/scene/box_inside.png",
  "./images/scene/box_inside_mask.png",
  "./images/scene/box_lines.png",
  "./images/scene/one-fire-box.png",
  "./images/scene/total_won.png",
  "./images/scene/pay_amount.png",
  "./images/scene/options_popup.png",
  "./images/scene/stop.png",

  "./images/fireworks/firework-1.png",
  "./images/fireworks/firework-2.png",
  "./images/fireworks/firework-3.png",
  "./images/fireworks/firework-4.png",
  "./images/fireworks/firework-5.png",
  "./images/fireworks/firework-6.png",
  "./images/fireworks/firework-7.png",
  "./images/fireworks/firework-8.png",
  "./images/fireworks/firework-9.png",
  "./images/fireworks/firework-10.png",
  "./images/fireworks/firework-11.png",
  "./images/fireworks/firework-12.png",
  "./images/fireworks/firework-13.png",
  "./images/fireworks/firework-14.png",
  "./images/fireworks/firework-15.png",
  "./images/fireworks/firework-16.png",
  "./images/fireworks/firework-17.png",
  "./images/fireworks/firework-18.png",
  "./images/fireworks/firework-19.png",
  "./images/fireworks/firework-20.png",
  "./images/fireworks/fire.png",

  "./images/string/string_sprite_sheet.png",

  "./images/buttons/play.png",
  "./images/buttons/play_hover.png",
  "./images/buttons/play_pressed.png",
  "./images/buttons/bonus_play.png",
  "./images/buttons/bonus_play_hover.png",
  "./images/buttons/bonus_play_pressed.png",
  "./images/buttons/auto_play.png",
  "./images/buttons/auto_play_hover.png",
  "./images/buttons/auto_play_pressed.png",
  "./images/buttons/plus.png",
  "./images/buttons/plus_hover.png",
  "./images/buttons/plus_pressed.png",
  "./images/buttons/minus.png",
  "./images/buttons/minus_hover.png",
  "./images/buttons/minus_pressed.png",
  "./images/buttons/options.png",
  "./images/buttons/options_hover.png",
  "./images/buttons/options_pressed.png",
  "./images/buttons/prize_chart.png",
  "./images/buttons/prize_chart_hover.png",
  "./images/buttons/prize_chart_pressed.png",
  "./images/buttons/howtoplay.png",
  "./images/buttons/howtoplay_hover.png",
  "./images/buttons/howtoplay_pressed.png",
  "./images/buttons/manuel_explode.png",
  "./images/buttons/manuel_explode_hover.png",
  "./images/buttons/manuel_explode_pressed.png",
  "./images/buttons/auto_explode.png",
  "./images/buttons/auto_explode_hover.png",
  "./images/buttons/auto_explode_pressed.png",
  "./images/buttons/5.png",
  "./images/buttons/5_hover.png",
  "./images/buttons/5_pressed.png",
  "./images/buttons/10.png",
  "./images/buttons/10_hover.png",
  "./images/buttons/10_pressed.png",
  "./images/buttons/15.png",
  "./images/buttons/15_hover.png",
  "./images/buttons/15_pressed.png",
  "./images/buttons/20.png",
  "./images/buttons/20_hover.png",
  "./images/buttons/20_pressed.png",

  "./images/buttons/sound_on.png",
  "./images/buttons/sound_off.png",


  "./images/explosion/explosion_empty.png",
  "./images/explosion/explosion_red.png",
  "./images/explosion/explosion_green.png",
  "./images/explosion/explosion_blue.png",
  "./images/explosion/explosion_purple.png",
].concat(winningIcons)


export const fireworkObject: FireworksInfo = {
  1: {
    type: FireworksType.checker,
    color: FireworksColor.red
  },
  2: {
    type: FireworksType.stars,
    color: FireworksColor.red
  },
  3: {
    type: FireworksType.swiggle,
    color: FireworksColor.red
  },
  4: {
    type: FireworksType.full,
    color: FireworksColor.red
  },
  5: {
    type: FireworksType.stripes,
    color: FireworksColor.red
  },
  6: {
    type: FireworksType.checker,
    color: FireworksColor.purple
  },
  7: {
    type: FireworksType.stars,
    color: FireworksColor.purple
  },
  8: {
    type: FireworksType.swiggle,
    color: FireworksColor.purple
  },
  9: {
    type: FireworksType.full,
    color: FireworksColor.purple
  },
  10: {
    type: FireworksType.stripes,
    color: FireworksColor.purple
  },
  11: {
    type: FireworksType.checker,
    color: FireworksColor.green
  },
  12: {
    type: FireworksType.stars,
    color: FireworksColor.green
  },
  13: {
    type: FireworksType.swiggle,
    color: FireworksColor.green
  },
  14: {
    type: FireworksType.full,
    color: FireworksColor.green
  },
  15: {
    type: FireworksType.stripes,
    color: FireworksColor.green
  },
  16: {
    type: FireworksType.checker,
    color: FireworksColor.blue
  },
  17: {
    type: FireworksType.stars,
    color: FireworksColor.blue
  },
  18: {
    type: FireworksType.swiggle,
    color: FireworksColor.blue
  },
  19: {
    type: FireworksType.full,
    color: FireworksColor.blue
  },
  20: {
    type: FireworksType.stripes,
    color: FireworksColor.blue
  },
}

export const testGridData2 = [
  [[3, 3, 13, 11, 1, 7, 15, 10, 3, 11, 1, 7, 2, 11, 5, 11, 16, 1, 5, 0, 0, 1]],
  [[8, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 0, 0, 2, 0]],
  [[19, 9, 5, 6, 16, 6, 20, 6, 12, 9, 9, 2, 15, 13, 4, 5, 1, 1, 0, 0, 2, 3], [17, 17, 10, 16, 17, 8, 17, 9, 8, 4, 20, 17, 13, 5, 8, 4, 19, 1, 0, 3, 3, 0]],
  [[12, 11, 14, 19, 3, 10, 15, 16, 7, 1, 20, 10, 2, 4, 12, 16, 9, 2, 0, 3, 1, 0]],
  [[15, 5, 20, 12, 8, 5, 17, 5, 7, 5, 3, 18, 1, 5, 5, 2, 10, 2, 2, 0, 3, 2], [15, 18, 8, 8, 11, 8, 15, 1, 1, 2, 20, 11, 1, 4, 9, 9, 5, 0, 3, 0, 0, 2]],
  [[13, 3, 7, 4, 14, 15, 4, 18, 15, 20, 14, 5, 2, 15, 18, 3, 4, 1, 4, 1, 2, 1]],
  [[15, 18, 8, 8, 11, 8, 15, 1, 1, 2, 20, 11, 1, 4, 9, 9, 5, 0, 3, 0, 0, 2]],
  [[2, 5, 13, 11, 11, 1, 19, 15, 5, 2, 2, 6, 3, 7, 15, 15, 13, 1, 2, 1, 3, 0], [5, 6, 4, 12, 5, 7, 4, 8, 13, 1, 8, 17, 13, 9, 17, 13, 6, 2, 1, 0, 0, 1]]
]

export const testGridData = [18, 10, 8, 14, 16, 13, 12, 11, 11, 6, 1, 9, 15, 2, 4, 1, 17, 3, 1, 0, 0, 0];